import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/reset.scss' // 引入重置样式
import './styles/font_tag/iconfont.css' // 引入图标样式
import { axios } from '@/utils/axios'
import 'lib-flexible/flexible' // 移动端适配 必须引入
import './assets/css/global.scss' // 自定义全局变量
// import VueI18n from 'vue-i18n' // 引入
// console.log('VueI18n', VueI18n)
// Vue.use(VueI18n)
// import '@/utils/appback.js' // 解决app直接退出问题
// 引入 vant
import '@/plugins/vant'
// // 自定义插件
import myPlugin from '@/plugins/myPlugin'
Vue.use(myPlugin)

// import VueClipboard from 'vue-clipboard2' // 复制插件
// Vue.use(VueClipboard)

// import preview from 'vue-photo-preview' // 全屏图片预览插件
// import 'vue-photo-preview/dist/skin.css'
// Vue.use(preview)


import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.prototype.$axios = axios

// 设置项 缓存取
// if(!localStorage.getItem("locale")){
// 	localStorage.getItem("locale", "zh");
// } else {
// 	localStorage.getItem("locale", localStorage.getItem("locale"));
// }

// 替换手机号中间四位
Vue.filter('telhidden', val => {
  const reg = /^(\d{3})\d{4}(\d{4})$/
  return val.replace(reg, '$1****$2')
})

import tool from './utils/public.js' // 注册流程
Vue.prototype.$tool = tool //工具类

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount('#app')
